import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster } from "../../../graphql/mutations";
import { getLastAuthUser } from "../../../library/shared";
import { createItemMaster } from "../../../graphql";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};

const DeleteSelectedItems = ({
  open,
  setOpen,
  itemsData,
  rows,
  setRows,
  setSelected,
  listItemDetails,
  setSummaryData,
  setdataCount,
}) => {
  const [finishedArr, setFinishedArr] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const userPreferenceAndFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  async function deleteGoodsItemDet(data) {
    try {
      const purchaseFlag = data.purchaseInvoiceFlag;
      const invoiceFlag = data.salesInvoiceFlag;
      data = {
        ...data,
        financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
        companyid: getCompany?.companyid,
        purchaseaccountid: purchaseFlag === 0 ? 0 : data.purchaseAccount?.value,
        purchaseinvoiceflag: purchaseFlag,
        salesaccountid: invoiceFlag === 0 ? 0 : data.salesAccount?.value,
        salesinvoiceflag: invoiceFlag,
      };
      const comments =
        typeof data?.remarks === "string" ? data?.remarks.split("\n") : [];
      let masterData = {
        currencycd: "13",
        hsnid: 0,
        itemid: data?.itemId || data?.itemid,
        itemcategorycd: data?.itemcategorycd
          ? data?.itemcategorycd
          : data?.itemCtegorey === ""
          ? 0
          : data?.itemCtegorey,
        itemcode: data?.itemCode || data?.itemcode,
        itemname: data?.itemName || data?.itemname,
        itemtype: data?.itemtype
          ? data?.itemtype
          : data?.type === 1
          ? "GOODS"
          : "SERVICE",
        measurementcd: data?.unit || data?.measurementcd,
        purchaseaccountid: data?.purchaseaccountid,
        purchaseinvoiceflag: data?.purchaseinvoiceflag,
        reversechargeflag: 0,
        salesaccountid: data?.salesaccountid,
        salesinvoiceflag: data?.salesinvoiceflag,
        taxabilitycd: data?.taxability?.value || data?.taxabilitycd,
        is_active: data?.is_active ? data?.is_active : data?.Is_Active ? 0 : 1,
        serialnumber: data?.voucherSeries?.value || data?.serialnumber,
        // enteredtimestamp: data?.timeStamp,
        // description: comments?.join("**"),
        expiredtimestamp: Math.floor(Date.now() / 1000),
        lastupdatedby: getLastAuthUser(),
        financialyearid: data?.financialyearid,
        companyid: data?.companyid,
        description: comments?.join("**"),
      };
      let res = await API.graphql(
        graphqlOperation(createItemMaster, {
          createItemMasterInput: masterData,
        })
      );

      if (res.data?.createItemMaster != null) {
        if (res.data?.createItemMaster.StatusCode === "Error") {
          console.log(res.data?.createItemMaster.StatusMessage);
          setFinishedArr((prev) => [
            ...prev,
            { ItemID: data.itemId, status: false },
          ]);
        } else {
          setFinishedArr((prev) => [
            ...prev,
            { ItemID: data.itemId, status: true },
          ]);
        }
      } else {
        setFinishedArr((prev) => [
          ...prev,
          { PartyID: data.itemId, status: false },
        ]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  useEffect(() => {
    if (itemsData?.length > 0) {
      if (finishedArr.length == itemsData?.length) {
        let arr = rows.filter((item, ind) => {
          if (
            itemsData.includes(item?.itemId) &&
            finishedArr.find(
              (e) => e.status === true && e.ItemID === item?.itemId
            ) !== undefined
          ) {
          } else {
            return item;
          }
        });
        console.log(arr, itemsData, rows, finishedArr);
        let deleted = finishedArr.filter((elem) => elem.status);
        setdataCount((prev) => prev - deleted.length);
        let notdeleted = finishedArr.filter((elem) => !elem.status);
        if (deleted.length) listItemDetails();
        setRows(arr);
        setOpen(false);
        let isItems = "Items";
        setSelected(notdeleted.map((elem) => elem.ItemID));
        if (deleted.length == 1 && !notdeleted.length) {
          showSuccessSnackbar(`${isItems} Deleted`);
        } else if (deleted.length > 1 && !notdeleted.length) {
          showSuccessSnackbar(`${isItems} Deleted`);
        } else if (notdeleted.length == 1 && deleted.length == 0) {
          showWarningSnackbar(
            `${isItems} Cannot Be Deleted As  Invoice Details Has Already Been Created For The ${isItems}`
          );
        } else {
          setSummaryData({
            open: true,
            description: `${isItems} Cannot Be Deleted  Invoice Details Has Already Been Created For The ${isItems} !`,
            lists: [
              ...notdeleted.map((elem) => {
                let items = rows.find((el) => el.itemId == elem.ItemID);
                return items.itemName;
              }),
            ],
            title: `Some ${isItems} cannot be deleted !`,
          });
        }
      }
    }
  }, [finishedArr]);

  const deleteItem = () => {
    if (itemsData?.length > 0) {
      setLoading(true);
      itemsData.map((item) => {
        let data = rows.find((items) => items.itemId === item);
        deleteGoodsItemDet(data);
      });
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            backgroundColor: "white",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography sx={{ color: "rgb(60 60 60)", fontWeight: "bold" }}>
            Do you want to delete this item?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            onClick={handleClose}
            disabled={loading}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteSelectedItems;
